import _ from "underscore";
import confirmTemplate from './confirm.html';

(function () {
    "use strict";
    angular.module("cardspotWeb.areas.lookupCustomer")
        .controller("LookupCustomer", LookupCustomer);

    LookupCustomer.$inject = ["$scope", "$uibModal", "lookupValues", "REGION_TYPES", "notify", "customerService", "authService", 
        "navigate", "preActivationService", "cardService", "$anchorScroll", "$timeout", "$routeParams", "$rootScope"];

    function LookupCustomer($scope, $uibModal, lookupValues, REGION_TYPES, notify, customerService,
        authService, navigate, preActivationService, cardService, $anchorScroll, $timeout, $routeParams, $rootScope) {
        var company = "company";
        var individual = "individual";
        var model = this;

        model.isEditMode = false;
        model.search = {
            searchType: null,
            organizationName: null,
            firstName: null,
            lastName: null,
            phoneNumber: null,
            identifier: null,
            email: null,
            kybAssessmentLevel: {
                id: null,
                name: null,
                isDefaultApproval: null
            },
            companyRegistrationNumber: null,
            assessmentFromDate: null,
            assessmentToDate: null
        };

        model.sort = sort;
        model.sortKey = "transactionId";
        model.reverse = true;
        $scope.currentPage = 1;
        $scope.pageSize = 10;

        model.customers = null;
        model.reset = reset;
        model.customerIsIndividual = customerIsIndividual;
        model.customerIsCompany = customerIsCompany;
        model.isIndividual = isIndividual;
        model.isCompany = isCompany;
        model.regions = [];
        model.countrySelectionChanged = countrySelectionChanged;
        model.tradingCountrySelectionChanged = tradingCountrySelectionChanged;
        model.showRegionSelection = false;
        model.customerRegionModel = customerRegionModel;
        model.selectCustomer = selectCustomer;
        model.currentCustomer = null;
        model.searchCustomers = searchCustomers;
        model.canEditCustomer = canEditCustomer;
        model.toggleEditMode = toggleEditMode;
        model.resetCustomer = resetCustomer;
        model.editCustomer = editCustomer;
        model.isValidSearchCriteria = isValidSearchCriteria;
        model.confirmActivateCards = confirmActivateCards;
        model.canActivateCard = authService.canActivateCard();
        model.canViewRestrictedCardNumbers = authService.canViewRestrictedCardNumbers();
        model.maskPrintText = cardService.maskPrintText;
        model.pageChanged = pageChanged;
        model.assessmentLevelChange = assessmentLevelChange;
        model.changeTab = changeTab
        model.showSelectedCountryOfOperation = showSelectedCountryOfOperation;
        model.showSelectedIncentiveTypes = showSelectedIncentiveTypes;
        model.onCardFundingSourceChange = onCardFundingSourceChange;
        model.toggleSelectedIncentiveTypes = toggleSelectedIncentiveTypes;
        model.toggleSelectedCountriesOfOperation = toggleSelectedCountriesOfOperation;
        model.onBirthdateChange = onBirthdateChange;
        model.onIncorporationDateChange = onIncorporationDateChange;
        model.showOrgContactView = showOrgContactView;
        model.showMiscInfoView = showMiscInfoView;
        model.showSourceOfFundsHeader = showSourceOfFundsHeader;
        model.currentDateFormat = $rootScope.currentDateFormat;
        model.altDateInputFormats = $rootScope.altDateInputFormats;
        $scope.master = {};
        $scope.datePopup = {
            opened: false
        };

        $scope.kybStartDatePopup = {
            opened: false
        }

        $scope.kybEndDatePopup = {
            opened: false
        }

        $scope.kybDatePopup = {
            opened: false
        }

        $scope.incorporationDatePopup = {
            opened: false
        }

        $scope.openDatePicker = function () {
            $scope.datePopup.opened = true;
        };

        $scope.openKybStartDatePicker = function () {
            $scope.kybStartDatePopup.opened = true;
        }

        $scope.openKybEndDatePicker = function () {
            $scope.kybEndDatePopup.opened = true;
        }

        $scope.openKybDatePicker = function () {
            $scope.kybDatePopup.opened = true;
        }

        $scope.openIncorporationDatePicker = function () {
            $scope.incorporationDatePopup.opened = true;
        }

		var TAB_NAMES = {
			CUSTOMER: "customer",
			PURCHASED_CARDS: "purchasedCards"
		};

		$scope.TAB_NAMES = TAB_NAMES;
		var activeTab = TAB_NAMES.CUSTOMER;

        $scope.tabClass = function (tabName) {
			var cssClass = "";
			if (tabName === activeTab) {
				cssClass = "active";
			}
			return cssClass;
		}

		$scope.tabVisible = function (tabName) {
			return tabName === activeTab;
		};

        init();

        function init() {
            initCustomer();
            initFilters();
        }

        function initCustomer() {
            if(($routeParams.name || $routeParams.firstName || $routeParams.lastName) && $routeParams.searchType) {
                model.search.searchType = $routeParams.searchType;
                var searchCustomerModel;
                if ($routeParams.searchType === company) {
                    model.search.organizationName = $routeParams.name;
                    model.search.kybAssessmentLevel = null;
                    searchCustomerModel = {
                        isOrganization: !isIndividual(),
                        name: model.search.organizationName
                    }
                } else {
                    model.search.firstName = $routeParams.firstName;
                    model.search.lastName = $routeParams.lastName;
                    searchCustomerModel = {
                        isOrganization: !isIndividual(),
                        firstName: model.search.firstName,
                        lastName: model.search.lastName
                    }
                }
                doSearchCustomers(searchCustomerModel);
            } else {
                var searchCustomerCriteria = customerService.getSearchCustomerCriteria();
                if (searchCustomerCriteria) {
                    model.search.searchType = searchCustomerCriteria.isOrganization ? company : individual;
                    model.search.organizationName = searchCustomerCriteria.name;
                    model.search.firstName = searchCustomerCriteria.firstName;
                    model.search.lastName = searchCustomerCriteria.lastName;
                    model.search.phoneNumber = searchCustomerCriteria.phoneNumber;
                    model.search.email = searchCustomerCriteria.email;
                    model.search.kybAssessmentLevel = searchCustomerCriteria.kybAssessmentLevel;
                    model.search.companyRegistrationNumber = searchCustomerCriteria.companyRegistrationNumber;
                    model.search.assessmentFromDate = searchCustomerCriteria.assessmentFromDate;
                    model.search.assessmentToDate = searchCustomerCriteria.assessmentToDate;
                    doSearchCustomers(searchCustomerCriteria);
                }
            }
        }

        function initFilters() {
            getCountries();
            getRiskAssessmentLevels();
            getCardFundingSources();
            getCompanyTypes();
            getIndustryTypes();
            getBusinessSizes();
            getCountriesOfOperation();
            getIncentiveTypes();
            getKybStatuses();
        }

        function confirmActivateCards() {
            var modalInstance = $uibModal.open({
                animation: false,
                template: confirmTemplate,
                controller: "ConfirmActivateCards",
                size: "sm"
            });

            modalInstance.result.then(function () {
                customerService.setActivateCardCustomer(model.currentCustomer);
                preActivationService.reset();
                navigate.toEnterSales(model.currentCustomer.isOrganization);
            });
        }

        function searchCustomers() {

            model.customers = null;
            model.currentCustomer = null;

            var searchCustomerModel = {
                isOrganization: !isIndividual(),
                name: model.search.organizationName,
                firstName: model.search.firstName,
                lastName: model.search.lastName,
                phoneNumber: model.search.phoneNumber ? model.search.phoneNumber.replace(/[^0-9]/g, '') : model.search.phoneNumber,
                identifier: model.search.identifier,
                email: model.search.email,
                kybAssessmentLevel: model.search.kybAssessmentLevel?.name,
                kybStatus: model.search.kybStatus?.description,
                companyRegistrationNumber: model.search.companyRegistrationNumber,
                assessmentFromDate: model.search.assessmentFromDate,
                assessmentToDate: model.search.assessmentToDate
            };
            notify.forFormSubmission($scope.searchCustomerForm, doSearchCustomers(searchCustomerModel));
        }

        function doSearchCustomers(searchCustomerModel) {
            notify.dismissErrorAlert();
            if (!isValidSearchCriteria()) {
                notify.showError("LOOKUP_CUSTOMER.FORM.INVALID_SEARCH_CRITERIA");
                return;
            }

            notify.forHttp(customerService.searchCustomers(searchCustomerModel), { startTranslationId: "LOOKUP_CUSTOMER.FORM.PROGRESS_TEXT" })
                .then(function (response) {
                    setSearchResults(response);
                });
        }

        function isValidSearchCriteria() {
            return (model.search.firstName || model.search.lastName || model.search.phoneNumber
                || model.search.organizationName || model.search.email || model.search.identifier
                || (model.search.kybAssessmentLevel && model.search.kybAssessmentLevel.name && model.search.kybAssessmentLevel.name !== "--Select Assessment Level--")
                || (model.search.kybStatus && model.search.kybStatus.description && model.search.kybStatus.description !== "--Select KYB Level--") || model.search.companyRegistrationNumber ||
                model.search.assessmentFromDate || model.search.assessmentToDate);
        }

        function setSearchResults(response) {

            if (!response.succeeded || !response.customers || response.customers.length === 0) {
                notify.showError("LOOKUP_CUSTOMER.NO_RESULTS_FOUND");
            } else {
                model.customers = response.customers;
                model.customers.forEach(c => {
                    c.birthDate = formatDate(c.birthDate);
                    c.assessmentDate = formatDate(c.assessmentDate);
                    c.incorporationDate = formatDate(c.incorporationDate);
                    if (c.documentedPerson) {
                        c.documentedPerson.birthDate = formatDate(c.documentedPerson.birthDate);
                        c.documentedPerson.identityExpirationDate = formatDate(c.documentedPerson.identityExpirationDate);
                    }
                });
            }
        }

        function formatDate(date) {
            if (date) {
                var d = new Date(date);
                return d;
            }
            return null;
        }

        function countrySelectionChanged() {

            model.currentCustomer.postalCode = null;
            model.currentCustomer.state = null;
            model.currentCustomer.province = null;

            if (model.currentCustomer.selectedCountry) {
                lookupValues.getRegions(model.currentCustomer.selectedCountry.countryKey)
                    .then(function (regions) {
                        model.regions = regions;
                        model.showRegionSelection = model.currentCustomer.selectedCountry && hasRegions() && model.currentCustomer.selectedCountry.regionType !== REGION_TYPES.NONE;
                    });
            }
        }

        function tradingCountrySelectionChanged() {

            model.currentCustomer.postalCode = null;
            model.currentCustomer.state = null;
            model.currentCustomer.province = null;

            if (model.currentCustomer.selectedTradingCountry) {
                lookupValues.getRegions(model.currentCustomer.selectedTradingCountry.countryKey)
                    .then(function (regions) {
                        model.tradingRegions = regions;
                        model.showTradingRegionSelection = model.currentCustomer.selectedTradingCountry && hasRegions() && model.currentCustomer.selectedTradingCountry.regionType !== REGION_TYPES.NONE;
                    });
            }
        }

        function customerRegionModel(newRegion) {
            if (model.currentCustomer && model.currentCustomer.country) {
                if (model.currentCustomer.country.regionType === REGION_TYPES.STATE) {
                    return arguments.length ? (model.currentCustomer.state = newRegion) : model.currentCustomer.state;
                } else {
                    return arguments.length ? (model.currentCustomer.province = newRegion) : model.currentCustomer.province;
                }
            }
        }

        function hasRegions() {
            return angular.isArray(model.regions) && model.regions.length > 0;
        }

        function reset() {
            model.search.firstName = null;
            model.search.lastName = null;
            model.search.organizationName = null;
            model.search.phoneNumber = null;
            model.search.identifier = null;
            model.search.email = null;
            model.search.kybAssessmentLevel = null;
            model.search.companyRegistrationNumber = null;
            model.search.assessmentFromDate = null;
            model.search.assessmentToDate = null;
            model.customers = null;
            model.currentCustomer = null;
            model.search.kybStatus = null;
            $scope.searchCustomerForm.$setPristine();
        }

        function isIndividual() {
            return model.search.searchType === individual;
        }

        function isCompany() {
            return model.search.searchType === company;
        }

        function customerIsIndividual() {
            reset();
            model.search.searchType = individual;
        }

        function customerIsCompany() {
            reset();
            model.search.searchType = company;
        }

        function sort(columnKey) {
            model.sortKey = columnKey;
            model.reverse = !model.reverse;
        }

        function selectCustomer(customer) {
            if (model.currentCustomer === customer) {
                model.currentCustomer = null;
                return;
            } else {
                model.isEditMode = false;
            }
            model.currentCustomer = customer;

            setSelectedRegisteredCountry(customer);
            setSelectedTradingCountry(customer);
            setSelectedCompanyType(customer);
            setSelectedIndustryType(customer);
            setSelectedBusinessSize(customer);
            setSelectedCardFundingSource(customer);
            setSelectedKybStatus(customer);
            
            doGetCustomerCards(customer);
            if (isCompany())
            {
                doGetCustomerIncentiveTypes(model.currentCustomer);
                doGetCustomerCountryOfOperation(model.currentCustomer);
            }
        }

        function onBirthdateChange(date) {
            var age = getAge(date);
            if (date > Date.now() || age < 18) {
                model.showInvalidBirthdateMessage = true;
                model.currentCustomer.birthDate = undefined;
            } else {
                model.showInvalidBirthdateMessage = false;
            }
        }

        function getAge(dateString) {
            var today = new Date();
            var birthDate = new Date(dateString);
            var age = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            return age;
        }

        function onIncorporationDateChange(date) {
            if (date > Date.now()) {
                model.showInvalidIncorporationDateMessage = true;
                model.currentCustomer.incorporationDate = undefined;
            } else {
                model.showInvalidIncorporationDateMessage = false;
            }
        }

        function setSelectedCardFundingSource(customer) {
            var source = _.find(model.cardFundingSources, function(cfs) {
                return cfs.id === customer.cardFundingSourceId;
            })
            if (source) {
                model.currentCustomer.selectedCardFundingSource = source;
                model.currentCustomer.cardFundingSourceOther = customer.cardFundingSourceOther;
                model.currentCustomer.cardFundingSource = source.description;
                model.showOtherDescription = model.currentCustomer.selectedCardFundingSource?.description?.startsWith("Other");
            }
        }

        function setSelectedIndustryType(customer) {
            var type = _.find(model.industryTypes, function (it) {
                return it.description === customer.industryType
            })
            model.currentCustomer.selectedIndustryType = type;
        }

        function setSelectedBusinessSize(customer) {
            var size = _.find(model.businessSizes, function (sz) {
                return sz.description === customer.businessSize
            })
            model.currentCustomer.selectedBusinessSize = size;
        }

        function setSelectedCompanyType(customer) {
            var type = _.find(model.companyTypes, function (ct) {
                return ct.description === customer.companyType
            })
            model.currentCustomer.selectedCompanyType = type;
        }

        function setSelectedRegisteredCountry(customer) {
            var country = _.find(model.countries, function (country) {
                return country.countryName === customer.country;
            });
            model.currentCustomer.selectedCountry = country;
            if (country) {
                lookupValues.getRegions(customer.country)
                    .then(function (regions) {
                        model.regions = regions;
                        model.showRegionSelection = model.currentCustomer.selectedCountry && hasRegions() && model.currentCustomer.selectedCountry.regionType !== REGION_TYPES.NONE;
                        var region = _.find(model.regions, function (region) {
                            if (customer.region.length > 2) {
                                return region.regionName === customer.region;
                            }
                            return region.regionKey === customer.region;
                        });
                        model.currentCustomer.selectedRegion = region;
                    });
            }
        }

        function setSelectedTradingCountry(customer) {
            var country = _.find(model.countries, function (country) {
                return country.countryName === customer.tradingCountry;
            });
            model.currentCustomer.selectedTradingCountry = country;
            if (country) {
                lookupValues.getRegions(customer.tradingCountry)
                    .then(function (regions) {
                        model.tradingRegions = regions;
                        model.showTradingRegionSelection = model.currentCustomer.selectedTradingCountry && hasRegions() && model.currentCustomer.selectedTradingCountry.regionType !== REGION_TYPES.NONE;
                        var region = _.find(model.regions, function (region) {
                            if (customer.tradingStateProvince.length > 2) {
                                return region.regionName === customer.tradingStateProvince;
                            }
                            return region.regionKey === customer.tradingStateProvince;
                        });
                        model.currentCustomer.selectedTradingRegion = region;
                    });
            }
        }

        function setSelectedKybStatus(customer) {
            var status = _.find(model.kybStatuses, function (st) {
                return st.description === customer.kybStatus;
            })
            model.currentCustomer.selectedKybStatus = status;
        }

        function onCardFundingSourceChange() {
            model.showOtherDescription = model.currentCustomer.selectedCardFundingSource?.description.startsWith("Other");
            if (!model.showOtherDescription)
                model.currentCustomer.cardFundingSourceOther = null;
        }

        function toggleEditMode(customer) {
            $scope.master = angular.copy(customer);
            model.isEditMode = !model.isEditMode;

            $timeout($anchorScroll("currentCustomerSection"))
        }

        function doGetCustomerCards(customer) {

            notify.forHttp(customerService.searchCustomerCards(customer.isOrganization, customer.customerId, $scope.currentPage, $scope.pageSize), { startTranslationId: "LOOKUP_CUSTOMER.FORM.GET_CUSTOMER_CARDS_PROGRESS_TEXT" })
                .then(function (response) {
                    customer.cards = response.cards;
                    model.totalItems = response.totalItems;

                    $timeout($anchorScroll("currentCustomerSection"))
                });
        }

        function doGetCustomerIncentiveTypes(customer) {
            notify.forHttp(customerService.getOrganizationIncentiveTypes(customer.customerId), 
            { startTranslationId: "LOOKUP_CUSTOMER.FORM.GET_ORGANIZATION_INCENTIVE_TYPES_PROGRESS_TEXT" })
            .then(function (resp) {
                customer.incentiveTypes = resp.incentiveTypes;
            });
        }

        function doGetCustomerCountryOfOperation(customer) {
            notify.forHttp(customerService.getOrganizationCountryOfOperation(customer.customerId), 
            { startTranslationId: "LOOKUP_CUSTOMER.FORM.GET_ORGANIZATION_COUNTRY_OF_OPERATION_PROGRESS_TEXT" })
            .then(function (resp) {
                customer.countryOfOperation = resp.countryOfOperation;
            });
        }

        function showSelectedCountryOfOperation(id) {
            if (angular.isArray(model.currentCustomer?.countryOfOperation) && model.currentCustomer.countryOfOperation.length > 0)
                return model.currentCustomer?.countryOfOperation?.findIndex(item => item.id === id) !== -1;
            else
                return false;
        }

        function showSelectedIncentiveTypes(id) {
            if (angular.isArray(model.currentCustomer.incentiveTypes) && model.currentCustomer.incentiveTypes.length > 0)
                return model.currentCustomer?.incentiveTypes?.findIndex(type => type.id === id) !== -1;
            else
                return false;
        }

        function toggleSelectedIncentiveTypes(id) {
            var sbs = "Small Benefits Scheme";
            const idx = model.currentCustomer.incentiveTypes.findIndex(type => type.id === id);
            const smallBenefitIdx = model.currentCustomer.incentiveTypes.findIndex(type => type.description === sbs);
            const incentiveType = model.incentiveTypes.find(type => type.id === id);
            
            if (idx > -1) {
                model.currentCustomer.incentiveTypes.splice(idx, 1);
            } else {
                if (incentiveType.description === sbs) {
                    model.currentCustomer.incentiveTypes.length = 0;
                    model.currentCustomer.incentiveTypes = [];
                    model.currentCustomer.incentiveTypes.push(incentiveType);
                } else {
                    if (smallBenefitIdx > -1)
                        model.currentCustomer.incentiveTypes.splice(smallBenefitIdx, 1);
                        
                    model.currentCustomer.incentiveTypes.push(incentiveType);
                }
            }
        }

        function toggleSelectedCountriesOfOperation(id) {
            const idx = model.currentCustomer.countryOfOperation.findIndex(type => type.id === id);

            if (idx > -1) {
                model.currentCustomer.countryOfOperation.splice(idx, 1);
            } else {
                const countryOfOperation = model.countriesOfOperation.find(item => item.id === id);
                model.currentCustomer.countryOfOperation.push(countryOfOperation);
            }
        }

        function canEditCustomer() {
            return authService.canAddCustomerInformation();
        }

        function resetCustomer(customer) {
            angular.copy($scope.master, customer);
            model.isEditMode = false;
        }

        function editCustomer(customer) {
            customer.isOrganization = !isIndividual();
            customer.country = customer.selectedCountry ? customer.selectedCountry.countryKey : null;
            customer.region = customer.selectedRegion ? customer.selectedRegion.regionKey : null;
            customer.tradingCountry = customer.selectedTradingCountry ? customer.selectedTradingCountry.countryKey : null;
            customer.tradingRegion = customer.selectedTradingRegion ? customer.selectedTradingRegion.regionKey : null;
            customer.companyTypeId = customer.selectedCompanyType ? customer.selectedCompanyType.id : null;
            customer.companyType = customer.selectedCompanyType ? customer.selectedCompanyType.description : null;
            customer.industryTypeId = customer.selectedIndustryType ? customer.selectedIndustryType.id : null;
            customer.industryType = customer.selectedIndustryType ? customer.selectedIndustryType.description : null;
            customer.businessSizeId = customer.selectedBusinessSize ? customer.selectedBusinessSize.id : null;
            customer.businessSize = customer.selectedBusinessSize ? customer.selectedBusinessSize.description : null;
            customer.cardFundingSourceId = customer.selectedCardFundingSource ? customer.selectedCardFundingSource.id : null;
            customer.cardFundingSource = customer.selectedCardFundingSource ? customer.selectedCardFundingSource.description : null;

            notify.forHttp(customerService.updateCustomer(customer), { startTranslationId: "LOOKUP_CUSTOMER.FORM.UPDATE_CUSTOMER_PROGRESS_TEXT" })
                .then(function () {
                    model.isEditMode = false;
                });
        }

        function pageChanged(newPageNumber, customer) {
            if (newPageNumber) {
                $scope.currentPage = newPageNumber;
                doGetCustomerCards(customer);
            }
        }

        function getCountries() {
            lookupValues.getCountries()
            .then(function (data) {
                model.countries = data;
            });
        }

        function getRiskAssessmentLevels() {
            lookupValues.getRiskAssessmentLevels()
                .then(function(resp) {
                    model.riskAssessmentLevels = resp.data;
                })
        }

        function getCardFundingSources() {
            customerService.getCardFundingSources()
            .then(function (resp) {
                if (resp.data.succeeded) {
                    model.cardFundingSources = resp.data.cardFundingSources;
                }
            })
        }

        function getCompanyTypes() {
            customerService.getCompanyTypes()
            .then(function (resp) {
                if (resp.data.succeeded) {
                    model.companyTypes = resp.data.companyTypes;
                }
            })
        }

        function getIndustryTypes() {
            customerService.getIndustryTypes()
            .then(function (resp) {
                if (resp.data.succeeded) {
                    model.industryTypes = resp.data.industryTypes;
                }
            })
        }

        function getBusinessSizes() {
            customerService.getBusinessSizes()
            .then(function (resp) {
                if (resp.data.succeeded) {
                    model.businessSizes = resp.data.businessSizes;
                }
            })
        }

        function getCountriesOfOperation() {
            customerService.getCountriesOfOperation()
            .then(function (resp) {
                if (resp.data.succeeded) {
                    model.countriesOfOperation = resp.data.countriesOfOperation;
                }
            })
        }

        function getIncentiveTypes() {
            customerService.getIncentiveTypes()
            .then(function (resp) {
                if (resp.data.succeeded) {
                    model.incentiveTypes = resp.data.incentiveTypes;
                }
            })
        }

        function getKybStatuses() {
            customerService.getKybStatuses()
            .then(function (resp) {
                if (resp.data.succeeded) {
                    model.kybStatuses = resp.data.kybStatuses;
                }
            })
        }

        function assessmentLevelChange() {
            console.log(model.search.kybAssessmentLevel);
        }

        function changeTab(tabName) {
            activeTab = tabName;
        }

        function showOrgContactView() {
            return !model.isEditMode && model.currentCustomer && model.isCompany() && (model.currentCustomer.consentName || model.currentCustomer.consentRole || model.currentCustomer.consentEmail);
        }

        function showMiscInfoView() {
            return !model.isEditMode && model.currentCustomer && model.isCompany() && 
            (model.currentCustomer.incentiveTypes.length > 0 
                || model.currentCustomer.plannedAnnualSpend 
                || model.currentCustomer.issuedInEuropeanEconomicArea !== null
                || model.currentCustomer.cardFundingSource 
                || model.currentCustomer.cardFundMethod !== null);
        }

        function showSourceOfFundsHeader() {
            return model.currentCustomer.cardFundingSource || model.currentCustomer.cardFundMethod !== null;
        }
    }
}());
